import { ReactComponent as MicrophoneIcon } from '$icons/uncolored/microphone.svg';
import { AdditionalDocument } from '$types/candidates';
import VisibilityForm from '$components/CandidateDetails/AdditionalFile/VisibilityForm';
import { useTranslation } from 'react-i18next';
import classes from './AudioGallery.module.css';

interface Props {
  audio: AdditionalDocument;
}

const AudioCard = ({ audio }: Props) => {
  const [t] = useTranslation('global');

  return (
    <div className={classes.card} data-testid="audio-card">
      <span className={classes.tag}>
        <MicrophoneIcon className="fill-internal-main w-3 h-3" />
        {t('AdditionalVideos.audio.tag')}
      </span>
      <p className={`break-words mt-2 ${classes.cardTitle}`}>
        {audio.Description || t('AdditionalVideos.audio.title')}
      </p>
      <audio className={classes.player} src={audio.Url} controls>
        <track kind="captions" />
      </audio>
      <div className="mt-2 text-xs">
        <VisibilityForm
          fileId={audio.Id}
          isCandidateVisibleDefaultValue={!!audio.IsCandidatesVisible}
          isEmployersVisibleDefaultValue={!!audio.IsEmployersVisible}
        />
      </div>
    </div>
  );
};

export default AudioCard;
